// extracted by mini-css-extract-plugin
export var circle = "_bb-1";
export var exitConfirmationModal = "_bb-5";
export var iframe = "_bb-0";
export var offline = "_bb-3";
export var online = "_bb-2";
export var workstationSelectError = "_bb-4";